import Vue from 'vue';

import _ from 'lodash';
import {uuid} from 'vue-uuid';

export default {
  state: {
    cart: null,
    orderedPhotos: {},
  },
  getters: {
    CART: state => {
      return state.cart;
    },
    ORDERED_PHOTOS: state => {
      return state.orderedPhotos;
    },
  },
  mutations: {
    SET_CART: (state, cart) => {
      state.cart = cart;
    },
    SET_ORDERED_PHOTOS: (state, data) => {
      state.orderedPhotos = data;
    },
    SET_PRODUCT_QUANTITY: (state, data) => {
      state.cart.albums[data.parentIndex].products[data.index].quantity = data.quantity;
    },
    DELETE_ALBUM: (state, index) => {
      state.cart.albums.splice(index, 1);
    },
    DELETE_PRODUCT: (state, data) => {
      state.cart.albums[data.parentIndex].products.splice(data.index, 1);
    },
  },
  actions: {
    INIT_CART: async (context) => {
      if (context.getters.USER) {
        try {
          const response = await Vue.axios.get('v2/cart', null);

          if (response) {
            const cart = response.data.data.payload &&
            response.data.data.payload !== ''
                ? JSON.parse(response.data.data.payload)
                : null;
            const localCart = localStorage.getItem('cart')
                ? JSON.parse(localStorage.getItem('cart'))
                : null;

            let items = [];

            if (cart) {
              for (const album of cart.albums) {
                const localAlbum = _.find(localCart ? localCart.albums : {}, {
                  album_id: album.album_id,
                });

                if (localAlbum) {
                  let existingAlbum = _.clone(localAlbum);
                  existingAlbum.products = [];

                  if (localAlbum.products.length > 0) {
                    for (const product of album.products) {
                      const localProduct = _.find(localAlbum.products, {
                        uuid: product.uuid,
                      });

                      if (!localProduct) {
                        existingAlbum.products.push(product);
                      }
                    }
                  }

                  if (existingAlbum.products.length > 0) {
                    items.push(existingAlbum);
                  }
                } else {
                  items.push(album);
                }
              }
            }

            if (items.length) {
              context.commit('SET_CART', localCart);
              context.dispatch('SET_ORDERED_PHOTOS', localCart);
            } else {
              context.dispatch('SET_CART', localCart);
            }

            return items;
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      } else {
        const cart = localStorage.getItem('cart')
            ? JSON.parse(localStorage.getItem('cart'))
            : null;
        context.commit('SET_CART', cart);
        context.dispatch('SET_ORDERED_PHOTOS', cart);
      }
    },
    ADD_TO_CART: (context) => {
      let product;

      let cart = {
        total: 0,
        albums: [],
        confirm: false,
      };

      if (context.getters.ORDER && context.getters.ORDER.productItem) {
        const variant = _.find(context.getters.ORDER.productItem.variants, {
          id: context.getters.ORDER.productVariantId,
        });

        const quantityMap = (item) => {
          item.quantity = +item.quantity;
          return item;
        };

        const bulkPrices = variant && variant.pricelist_product_variants.length > 0
            ? _.sortBy(_.first(variant.pricelist_product_variants).
                bulk_prices.
                map(quantityMap), 'quantity').reverse()
            : [];

        let next_bulk_price = null,
            price = null;

        const nextBulkPrice = _.last(bulkPrices.filter(item => {
          return context.getters.ORDER.quantity < +item.quantity;
        }));

        if (nextBulkPrice) {
          next_bulk_price = {
            quantity: nextBulkPrice.quantity,
            price: nextBulkPrice.price_gross,
          };
        }

        if (bulkPrices.length > 0) {
          for (let i = 0; i < bulkPrices.length; i++) {
            if (context.getters.ORDER.quantity >= +bulkPrices[i].quantity) {

              if (context.getters.ORDER.product.isDownloadable) {
                let tax = 0;

                if (context.getters.USER && context.getters.USER.country && +context.getters.USER.country.tax_percent > 0) {
                  tax = +context.getters.USER.country.tax_percent;
                } else if (context.getters.CORE_PARAMS.owner && context.getters.CORE_PARAMS.owner.country && +context.getters.CORE_PARAMS.owner.country.tax_percent > 0) {
                  tax = +context.getters.CORE_PARAMS.owner.country.tax_percent;
                }

                price = (bulkPrices[i].price * (1 + tax));
              } else {
                price = bulkPrices[i].price_gross;
              }

              break;
            }
          }
        }

        if (!price && variant && variant.price) {
          price = variant.price;
        }

        const photos = context.getters.ORDER.photos.map((photo) => {
          if (photo.quantity > 0) {
            if (!photo.processing.cropper.selection) {
              photo.processing.cropper.selection = null;
              photo.processing.cropper.selectionCropBox = null;
            }

            return {
              photo_id: photo.id,
              price: price,
              quantity: photo.quantity,
              processing: photo.processing,
              sizes: [],
            };
          }
        }).filter(item => item);

        product = {
          uuid: context.getters.ORDER.productItem.uuid
              ? context.getters.ORDER.productItem.uuid
              : uuid.v1(),
          product_category_id: context.getters.ORDER.product.id,
          product_id: context.getters.ORDER.productItem.id,
          quantity: context.getters.ORDER.productItem.quantity
              ? context.getters.ORDER.productItem.quantity
              : 1,
          price,
          thumb_image: context.getters.ORDER.productItem.thumb_image,
          name: context.getters.ORDER.productItem.name,
          snippet: context.getters.ORDER.productItem.snippet,
          slug: context.getters.ORDER.product.slug,
          product_variant_id: context.getters.ORDER.productVariantId,
          product_variant_name: context.getters.ORDER.productVariantName,
          pricelist_product_id: context.getters.ORDER.pricelistProductId,
          bulk_price_id: context.getters.BULK_PRICE
              ? context.getters.BULK_PRICE.id
              : 0,
          total: price,
          photos_quantity: context.getters.ORDER.quantity,
          tag: context.getters.ALBUM_TAG,
          photos,
          next_bulk_price,
        };
      }

      if (context.getters.SET) {
        product = context.getters.SET;
      }

      const album = {
        album_id: context.getters.ALBUM.id,
        album_hash: context.getters.ALBUM.hash,
        album_hash_password: context.getters.ALBUM.hash_password,
        album_title: context.getters.ALBUM.title,
        album_status: context.getters.ALBUM.status,
        products: [product],
      };

      album.products = [product];

      if (context.getters.CART) {
        cart.albums = context.getters.CART.albums;

        const albumIndex = _.findIndex(context.getters.CART.albums,
            {album_id: album.album_id});

        if (albumIndex >= 0) {
          let uuid;

          if (context.getters.ORDER && context.getters.ORDER.productItem) {
            uuid = context.getters.ORDER.productItem.uuid;
          }

          if (context.getters.SET) {
            uuid = context.getters.SET.uuid;
          }

          const productIndex = _.findIndex(cart.albums[albumIndex].products, {
            uuid,
          });

          if (productIndex >= 0) {
            cart.albums[albumIndex].products[productIndex] = product;
          } else {
            cart.albums[albumIndex].products.push(product);
          }
        } else {
          cart.albums.push(album);
        }
      } else {
        cart.albums = [album];
      }

      context.dispatch('RECOUNT_PRODUCTS', cart);
    },
    SET_CART: async (context, cart) => {
      context.commit('SET_CART', cart);
      localStorage.setItem('cart', JSON.stringify(cart));

      if (context.getters.USER) {
        await Vue.axios.post('v2/cart', {
          payload: JSON.stringify(cart),
        });
      }

      context.dispatch('SYNC_CART_BY_ORDER_AS_GUEST', cart);
      context.dispatch('SET_ORDERED_PHOTOS', cart);
    },
    SET_ORDERED_PHOTOS: async (context, cart) => {
      let data = {};

      if (cart) {
        cart.albums.forEach(album => album.products.forEach(product => {
          if (product.photos) {
            product.photos.forEach(photo => {
              if (!data[photo.photo_id]) {
                data[photo.photo_id] = photo.photo_id;
              }
            });
          } else if (product.products) {
            product.products.forEach(product => {
              if (product.photo && product.photo.id &&
                  !data[product.photo.id]) {
                data[product.photo.id] = product.photo.id;
              }
            });
          }
        }));
      }

      context.commit('SET_ORDERED_PHOTOS', data);
    },
    SET_PRODUCT_QUANTITY: async (context, data) => {
      context.commit('SET_PRODUCT_QUANTITY', data);
      await context.dispatch('RECOUNT_PRODUCTS');
    },
    SYNC_CART_BY_ORDER_AS_GUEST: async (context, cart) => {
      if (context.getters.CHECKOUT) {
        if (context.getters.CHECKOUT.orderAsGuest) {
          await Vue.axios.put(
              `v2/temp-order/${context.getters.CHECKOUT.authType}/${context.getters.TMP_ORDER.id}`,
              {form: {}, cart: JSON.stringify(cart)});
        }

        const checkout = context.getters.CHECKOUT;
        checkout.orderAsGuest = false;

        context.dispatch('SET_CHECKOUT', checkout);
      }
    },
    CLEAR_CART: (context) => {
      context.commit('SET_CART', null);
      localStorage.removeItem('cart');

      context.commit('SET_ORDERED_PHOTOS', {});

      context.dispatch('CLEAR_CHECKOUT');
      context.dispatch('CLEAR_TMP_ORDER');
      context.dispatch('SET_CHECKOUT_STEP', 1);

      localStorage.removeItem('checkout');

      setTimeout(() => {
        if (context.getters.USER) {
          Vue.axios.delete('v2/cart');
        }
      });
    },
    DELETE_PRODUCT: (context, data) => {
      context.commit('DELETE_PRODUCT', data);

      if (!context.getters.CART.albums[data.parentIndex].products.length) {
        context.commit('DELETE_ALBUM', data.parentIndex);
      }

      context.dispatch('RECOUNT_PRODUCTS');
    },
    RECOUNT_PRODUCTS: async (context, cart = context.getters.CART) => {
      let total = 0,
          quantity = 0;

      cart.albums.forEach((album) => {
        if (album.products) {
          album.products.forEach((product) => {
            if (product.slug && product.slug === 'digital') {
              let price = 0;
              product.photos.forEach((photo) => {
                price += photo.price * photo.quantity;
              });
              product.total = price * product.quantity;
            } else {
              product.total = product.price * product.quantity;
            }

            total += product.total;
            quantity++;
          });
        }
      });

      if (cart.albums.length > 0) {
        cart.quantity = quantity;
        cart.total = total;
        await context.dispatch('SET_CART', cart);
      } else {
        context.dispatch('CLEAR_CART', cart);
      }
    },
    MERGE_PRODUCTS: (context, albums) => {
      let cart = context.getters.CART;

      albums.forEach((album) => {
        const indexAlbum = _.findIndex(cart ? cart.albums : {},
            {album_id: album.album_id});

        if (indexAlbum >= 0) {
          album.products.forEach((product) => {
            cart.albums[indexAlbum].products.push(product);
          });
        } else {
          if (cart) {
            cart.albums.push(album);
          } else {
            cart = {
              total: 0,
              albums: [album],
              confirm: false,
            };
          }
        }
      });

      context.dispatch('RECOUNT_PRODUCTS', cart);
    },
  },
};